export default "__VITE_ASSET__Bkry6G5R__"